"use strict";exports.__esModule = true;exports.default = void 0;class _default {
  onCreate() {
    this.state = { dismissed: false };
  }

  onInput(input) {
    this.state = { dismissed: input.dismissed || false };
  }

  onDismiss() {
    this.state.dismissed = true;
    this.emit('dismiss');
  }
}exports.default = _default;module.exports = exports.default;